import { APIConfig } from '@aws-amplify/core';

export const AmplifyConfigAPI: APIConfig = {
    REST: {
        // headers: async () => {
        //     return { Authorization: customAuthToken };
        // },
        api:{
            endpoint: process.env.REACT_APP_API_ENDPOINT!,
            region: process.env.REACT_APP_AUTH_REGION,
        },
    }
}

// export const AmplifyConfigAPI = {
//     endpoints: [
//         {
//             name: 'api',
//             endpoint: process.env.REACT_APP_API_ENDPOINT,
//             custom_header: async () => {
//                 return {
//                     Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
//                     'Content-Type': 'application/json',
//                 };
//             }
//         },
//     ],
// }